import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-3xl px-4 py-14 md:px-6 md:py-24">
        <div className="flex flex-col gap-2 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">食用 FAQ</p>
          <h2 className="font-heading text-2xl font-black tracking-tight md:text-4xl">吃瓜王的正确打开方式</h2>
          <p className="mx-auto max-w-xl text-sm text-foreground-700 md:text-base">瓜怎么来、榜怎么评、边界在哪，一次讲清，别边吃边误会。</p>
        </div>

        <div className="mt-9 flex flex-col gap-3">
          {faqItems.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{f.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-base`}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700 md:px-6">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}